// Microsoft Clarity (the tag in public/index.html): ties its recordings to our users.
// https://learn.microsoft.com/en-us/clarity/setup-and-installation/identify-api

declare global {
    interface Window {
        clarity?: (...args: unknown[]) => void;
    }
}

let current: string | null = null;
const tags: Record<string, string> = {};
let registered = false;

// custom-id reaches Clarity only as its SHA-256 hex; the same value as friendly-name keeps the
// uuid itself readable in recordings.
const identify = () => {
    if (current) window.clarity?.("identify", current, null, null, current);
};
const tag = (key: string) => window.clarity?.("set", key, tags[key]);

// Every URL change starts a Clarity page without identity or tags: metadata(cb, false, recall=true)
// re-sends them on each page, later changes go to the current one by hand (Clarity appends repeats).
const onEveryPage = (applyChange: () => void) => {
    if (registered) return applyChange();
    registered = true;
    window.clarity?.("metadata", () => {
        identify();
        Object.keys(tags).forEach(tag);
    }, false, true);
};

/**
 * Tags this tab's Clarity recordings with the user's uuid, until it is called with another one.
 * Without a uuid (logged out) the pages that follow stay untagged.
 */
export const identifyClarity = (uuid: string | null | undefined) => {
    // No tag on the embedded widget.
    if (!window.clarity || (uuid || null) === current) return;
    current = uuid || null;
    onEveryPage(identify);
};

/** Adds a custom tag to this tab's Clarity recordings, from now on. */
export const tagClarity = (key: string, value: string | null) => {
    if (!window.clarity || !value || tags[key] === value) return;
    tags[key] = value;
    onEveryPage(() => tag(key));
};
